import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { subscribeDlpLiveStreamingEpic, unsubscribeDlpLiveStreamingEpic } from './liveRealtimeEpic';
import { loadAfterDlpFormTabContentFetchedEpic } from './loadAfterDlpFormTabContentFetchedEpic';
import { persistDlpOrderTabContentEpic } from './persistDlpOrderTabContentEpic';
import { placeDlpOrderEpic } from './placeDlpOrderEpic';
import { triggerDlpOrderTabContentPersistenceEpic } from './triggerDlpOrderTabContentPersistenceEpic';

export const secondaryMarketDlpOrder = () =>
  combineEpics(
    withAppCrashIfException('persistDlpOrderTabContentEpic', persistDlpOrderTabContentEpic()),
    withAppCrashIfException('loadAfterDlpFormTabContentFetchedEpic', loadAfterDlpFormTabContentFetchedEpic()),
    withAppCrashIfException('placeDlpOrderEpic', placeDlpOrderEpic()),
    withAppCrashIfException('triggerDlpOrderTabContentPersistenceEpic', triggerDlpOrderTabContentPersistenceEpic()),
    withAppCrashIfException('subscribeDlpLiveStreamingEpic', subscribeDlpLiveStreamingEpic()),
    withAppCrashIfException('unsubscribeDlpLiveStreamingEpic', unsubscribeDlpLiveStreamingEpic()),
  );
